import { useSelector } from 'react-redux'

import { selectUserAccountPreferences } from '@/features/domain/user'

import { Divider } from '@mui/material'

import { useTexts } from '../../../useTexts'
import { useErrorLabels } from './useErrorLabels'

import { useNotificationTimeOptions } from './hooks/useNotificationTimeOptions'

import { form } from '../../../formState'

export function NotificationTime() {
  const { timeFormat } = useSelector(selectUserAccountPreferences)
  const errorLabels = useErrorLabels()
  const options = useNotificationTimeOptions()
  const texts = useTexts()

  const format = timeFormat === 'HH:mm' ? '24' : '12'
  const isFieldVisible = form.useForm().fields.notificationCutoffMins?.visible

  return (
    <>
      <form.TimePicker
        name="notificationCutoffMins"
        label={texts.notificationCutoffMinsLabel}
        testId="notificationCutoffMins"
        timePickerProps={{
          format: format,
          errorLabels: errorLabels,
          optionValues: options,
          allowUnlistedValues: true,
          helperText: texts.notificationCutoffMinsLabelHelperText,
        }}
      />

      {isFieldVisible && <Divider />}
    </>
  )
}
